export default __webpack_public_path__ + "static/media/23.1a0b8c21.jpg";